<template>
	<div :class="{loader: isLoading}" v-if="!isLoading">
		<div
			class="row history-item py-2"
			v-for="(item, index) in historyItems"
			:key="'history' + index"
			:class="{canceled: item.activity == 'canceled', completed: item.activity == 'completed'}"
		>
			<div class="col-md-12 p-0">
				<strong>
					<i>{{item.creator}}</i>
				</strong>
				{{$t(`signing.activities.${item.activity}`)}} - {{$moment(item.createdOn).format('DD MMM YYYY HH:mm')}}
			</div>
			<div v-if="item.text" class="col-md-12 p-0">
				<strong>{{$t('coordinations.comment')}}:</strong>
				{{item.text}}
			</div>
		</div>
	</div>
</template>

<script>
import signingService from '@/services/signing.service';

export default {
	props: {
		signingId: { type: Number, required: true }
	},
	data() {
		return {
			historyItems: [],
			isLoading: false
		};
	},
	methods: {
		async fetchHistory() {
			try {
				var result = await signingService.getHistory(this.signingId);
                if (result.data) {
                    result.data.forEach(el => {
                        this.historyItems.push(el);
                    });
                }
			} catch (err) {
				this.$vs.notify({
					color: 'danger',
					title: this.$t('notifications.error'),
					text: this.$helpers.errorText(err)
				});
			}
		}
	},
	mounted() {
		this.fetchHistory();
	}
};
</script>

<style lang="scss" scoped>
.history-item {
	border-bottom: 1px solid lightgrey;
	padding-left: 3px;

	&.canceled {
		border-left: 3px solid rgba(255, 0, 0, 0.5);
	}

	&.completed {
		border-left: 3px solid rgba(0, 0, 255, 0.5);
	}
}
</style>
